import React from 'react';

class AudioComponent extends React.Component {
    render() {
        const {
            soundToBePlayedAfterSuccessRegister
        } = this.props;

        return (
            soundToBePlayedAfterSuccessRegister != null &&
            <audio id="audio" src={soundToBePlayedAfterSuccessRegister}></audio>
        );
    }
}

export default AudioComponent;
